module.exports = __webpack_public_path__ + "img/130.9b82ec2d.jpg";